import type { ReactNode } from 'react';

export const symbol_history_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-145 0-254.5-90T89-399q-2-12 4.5-22t19.5-12q12-2 22 5.5t13 20.5q26 117 118.5 192T480-140q142 0 241-99t99-241q0-142-99-241t-241-99q-96 0-178.5 51T177-633h97q13 0 21.5 8.5T304-603q0 13-8.5 21.5T274-573H134q-17 0-26-13t-4-29q42-119 145-192t231-73q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm30-412 106 106q9 9 9 21t-9 21q-9 9-21 9t-21-9L459-459q-5-5-7-10t-2-11v-164q0-13 8.5-21.5T480-674q13 0 21.5 8.5T510-644v152Z"
		/>
	</svg>
);
